import axios from 'axios';
import config from 'src/config';

export const clientApi = axios.create({
  baseURL: config.API_DOMAIN,
});
